export default "__VITE_ASSET__963606f3__"